<template>

 <iframe :src="`http://docs.google.com/viewer?url=${url}&embedded=true`"  
 style="border: none; padding:0;width:100%;height:100%;"></iframe>
</template>
<script>
export default{
    name:'docsViewer',
     props:{
        url:{
            type: String,
            required:true,
        }
    }
    
}
</script>